import React from 'react';
import PropTypes from 'prop-types';

export function DeleteTagWarning(props) {
    return (
        <ul className={`listBulletIndent__spacedSm ${props.className}`}>WARNING - Deleting this Tag will:
            <li>Cause Integration Lauches (LTI, etc.) using this Tag to no longer allow the selection of activities using this Tag</li>
            <li><em>NOT</em> affect any existing assignments already using activities assoicated with this Tag</li>
        </ul>
    );
}

DeleteTagWarning.propTypes = { className: PropTypes.string };
DeleteTagWarning.defaultProps = { className: '' };


export function UpdateTagNameWarning(props) {
    return (
        <ul className={`listBulletIndent__spacedSm ${props.className}`}>WARNING - Updating Tag Name will:
            <li>Update activities using the old Tag Name to use the new Tag Name</li>
            <li>Update activities in projects using the old Tag Name to use the new Tag Name</li>
            <li>Cause Integration Lauches (LTI, etc.) using the old Tag Name to no longer allow the selection of activities using this Tag Name</li>
            <li>Cause Integration Lauches (LTI, etc.) using the new Tag Name to allow the selection of activities using the new Tag Name</li>
            <li><em>NOT</em> affect any existing assignments already using activities assoicated with the old Tag Name</li>
        </ul>
    );
}

UpdateTagNameWarning.propTypes = { className: PropTypes.string };
UpdateTagNameWarning.defaultProps = { className: '' };


export function ImportTagsInfo(props) {
    return (
        <div className={props.className}>
            <p className="margin-bottom-md">
                Importing tags will <strong className="font-weight-bold">merge</strong> the tags present in the imported file with existing Integration Tags.
                After importing, you will be prompted to confirm all pending changes before changes are finalized. 
                Once changes are finalized, they <strong className="font-weight-bold">cannot be automatically undone</strong>. 
                Tag file size limit is 3Mb.
            </p>
            <ul className="listBulletIndent__spacedSm">Imported files will be interpreted using these rules:
                <li>The first row of the imported file must have the column headings: <strong className="font-weight-bold font-style-italic">Tag Name</strong> and <strong className="font-weight-bold font-style-italic">Description</strong></li>
                <li>Imported tag rows with a <em className="font-style-italic">Tag Name</em> that does not match an existing tag will be <strong className="font-weight-bold">added</strong></li>
                {/*<li>Existing Integration Tags that have a tag name not present in the imported file will be <span className="font-weight-bold">deleted</span></li>*/}
                <li>Imported tag rows with a matching <em className="font-style-italic">Tag Name</em> but a different <em className="font-style-italic">Description</em> will be <strong className="font-weight-bold">updated</strong> with the new <em className="font-style-italic">Description</em>.</li>
                <li>Imported tag rows with a matching <em className="font-style-italic">Tag Name</em> and matching <em className="font-style-italic">Description</em>  <strong className="font-weight-bold">will not alter</strong> the existing tag</li>
            </ul>
        </div>
    );
}

ImportTagsInfo.propTypes = { className: PropTypes.string };
ImportTagsInfo.defaultProps = { className: '' };


export function ExportTagsInfo(props) {
    return (
        <div className={props.className}>
            <p className="margin-bottom-sm">
                Exporting tags will generate a CSV file containing all current Integration Tags for this organization. 
                Integration Tag names will be paired with their matching description. The exported file may be edited and used with the Import Tags feature.
            </p>
            <p>
                <span className="font-weight-bold">Note:</span> Use caution when editing CSV files using spreadsheet programs. 
                Spreadsheet programs may interpret tag names as <span className="font-style-italic">numbers</span> which may result in automatic formatting and data loss.
            </p>
        </div>
    );
}

ExportTagsInfo.propTypes = { className: PropTypes.string };
ExportTagsInfo.defaultProps = { className: '' };


export function TagNameInfo(props) {
    return (
        <div className={props.className}>
            <p>
                <strong className="font-weight-bold">Note:</strong> Leading and trailing whitespace will automatically be trimmed from Tag Name.
            </p>
        </div>
    );
}

TagNameInfo.propTypes = { className: PropTypes.string };
TagNameInfo.defaultProps = { className: '' };

